import { Bot, Phone, MessageSquare, Mail, AlertTriangle, CheckCircle2 } from "lucide-react";

const demoItems = [
  {
    id: "demo-1",
    type: "lead",
    icon: Phone,
    title: "Lead telefónico",
    client: "Cliente pendiente",
    summary: "El asistente telefónico podrá dejar aquí llamadas importantes, presupuestos o solicitudes urgentes.",
    status: "Pendiente",
  },
  {
    id: "demo-2",
    type: "quote",
    icon: MessageSquare,
    title: "Solicitud de presupuesto",
    client: "Futuro cliente",
    summary: "Aquí aparecerán consultas recogidas por IA, WhatsApp, formularios o asistentes externos.",
    status: "Pendiente",
  },
  {
    id: "demo-3",
    type: "notice",
    icon: Mail,
    title: "Aviso interno IA",
    client: "Sistema KAPEI",
    summary: "Esta bandeja será el punto central para revisar tareas generadas por automatizaciones.",
    status: "Informativo",
  },
];

export default function AdminAIInbox() {
  return (
    <div>
      <div className="mb-6 flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
        <div>
          <div className="inline-flex items-center gap-2 rounded-full bg-[#4d7c0f]/10 px-4 py-2 text-sm font-black text-[#4d7c0f]">
            <Bot className="h-4 w-4" />
            IA interna
          </div>
          <h1 className="mt-3 text-3xl font-black text-slate-900">Bandeja IA</h1>
          <p className="mt-1 max-w-2xl text-sm text-slate-600">
            Centro interno para revisar leads, avisos, incidencias y tareas que lleguen desde el asistente telefónico,
            WhatsApp, formularios o automatizaciones.
          </p>
        </div>

        <div className="rounded-2xl border border-amber-200 bg-amber-50 p-4 text-sm font-bold text-amber-800">
          <div className="flex items-start gap-2">
            <AlertTriangle className="mt-0.5 h-5 w-5 shrink-0" />
            <span>Versión inicial: estructura visual preparada. La conexión con IA/n8n se añadirá después.</span>
          </div>
        </div>
      </div>

      <div className="mb-5 grid grid-cols-1 gap-3 md:grid-cols-3">
        <div className="rounded-2xl border border-slate-200 bg-white p-5">
          <div className="text-xs font-black uppercase text-slate-500">Pendientes</div>
          <div className="mt-1 text-3xl font-black text-slate-900">0</div>
        </div>
        <div className="rounded-2xl border border-slate-200 bg-white p-5">
          <div className="text-xs font-black uppercase text-slate-500">Hoy</div>
          <div className="mt-1 text-3xl font-black text-slate-900">0</div>
        </div>
        <div className="rounded-2xl border border-slate-200 bg-white p-5">
          <div className="text-xs font-black uppercase text-slate-500">Revisadas</div>
          <div className="mt-1 text-3xl font-black text-slate-900">0</div>
        </div>
      </div>

      <div className="rounded-2xl border border-slate-200 bg-white">
        <div className="border-b border-slate-100 p-5">
          <h2 className="text-lg font-black text-slate-900">Ejemplos de lo que aparecerá aquí</h2>
          <p className="mt-1 text-sm text-slate-600">
            Estos ejemplos no son datos reales. Sirven para visualizar la futura bandeja.
          </p>
        </div>

        <div className="divide-y divide-slate-100">
          {demoItems.map((item) => {
            const Icon = item.icon;
            return (
              <div key={item.id} className="p-5">
                <div className="flex items-start gap-4">
                  <div className="grid h-12 w-12 shrink-0 place-items-center rounded-2xl bg-[#4d7c0f]/10 text-[#4d7c0f]">
                    <Icon className="h-6 w-6" />
                  </div>

                  <div className="min-w-0 flex-1">
                    <div className="flex flex-col gap-2 md:flex-row md:items-start md:justify-between">
                      <div>
                        <div className="text-lg font-black text-slate-900">{item.title}</div>
                        <div className="text-sm font-bold text-slate-500">{item.client}</div>
                      </div>

                      <span className="inline-flex w-fit items-center gap-1 rounded-full bg-slate-100 px-3 py-1 text-xs font-black text-slate-700">
                        <CheckCircle2 className="h-3.5 w-3.5" />
                        {item.status}
                      </span>
                    </div>

                    <p className="mt-3 text-sm text-slate-700">{item.summary}</p>

                    <div className="mt-4 flex flex-wrap gap-2">
                      <button className="rounded-xl bg-[#4d7c0f] px-4 py-2 text-xs font-black text-white opacity-50" disabled>
                        Marcar revisado
                      </button>
                      <button className="rounded-xl border border-slate-200 px-4 py-2 text-xs font-black text-slate-500" disabled>
                        Crear tarea
                      </button>
                      <button className="rounded-xl border border-slate-200 px-4 py-2 text-xs font-black text-slate-500" disabled>
                        Contactar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
